export default {
  busList: [],
  busInfo: null,
  busLayoutList: null,
  studentListForBus: [],
  plateList: null,
  currentFilter: null,
  currentSort: null,
  currentPage: null
}
